import React, { Fragment } from 'react';
import Select from 'react-select';
import { getOptions } from '../../../utils/commonUtil';
import Switch from '../../../components/shared/Switch';
import IconDoc from '../../../components/shared/CustomIcons';
import SchemeCard from './SchemeCard';

const EditScheme = (props) => {
  const { setNRN, setApplyCountry, scheme, options, setBtnClass, className } = props;

  const handleCheckboxChange = (event, setFieldValue) => {
    const targetValue = event.target.checked;
    if (targetValue) {
      setBtnClass('btn-green');
    } else {
      setBtnClass('btn-white');
    }
    setFieldValue(event.target.id, targetValue);
  };

  return (
    <>
      <hr />
      <div className="container-fluid mt-2  shadow bg-light jumbotron p-5 ">
        <div className="row ml-2 ">
          <IconDoc className="col-xs-12 col-sm-2 col-lg-2" iconName={'documents'} style />

          <h5 className="col-xs-12 col-sm-10 col-lg-10 mt-2 pl-2" style={{ color: '#c41719' }}>
            Documents Required
          </h5>
        </div>

        <hr />
        <div className="row ">
          <table className="col-lg-12 col-xs-12 table  table-borderless ">
            <thead>
              <tr>
                <th scope="col-5"></th>
                <th scope="col-2" style={{ textAlign: 'center' }}>
                  Account Opening From Nepal
                </th>
                <th scope="col-3" style={{ textAlign: 'center' }}>
                  Nepalese Citizen Working Overseas
                </th>
                <th scope="col-2" style={{ textAlign: 'center' }}>
                  NRN
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">Citizenship</th>
                <td>
                  <IconDoc iconName={'checked'} />
                </td>
                <td>
                  <IconDoc iconName={'cross'} />
                </td>
                <td>
                  <IconDoc iconName={'cross'} />
                </td>
              </tr>
              <tr>
                <th scope="row">Signature Specimen</th>
                <td>
                  <IconDoc iconName={'checked'} />
                </td>
                <td>
                  <IconDoc iconName={'checked'} />
                </td>
                <td>
                  <IconDoc iconName={'checked'} />
                </td>
              </tr>
              <tr>
                <th scope="row">Passport</th>
                <td>
                  {' '}
                  <IconDoc iconName={'cross'} />
                </td>
                <td>
                  <IconDoc iconName={'checked'} />
                </td>
                <td>
                  <IconDoc iconName={'checked'} />
                </td>
              </tr>
              <tr>
                <th scope="row">Visa or Visa Documents</th>
                <td>
                  <IconDoc iconName={'cross'} />
                </td>
                <td>
                  <IconDoc iconName={'checked'} />
                </td>
                <td>
                  {' '}
                  <IconDoc iconName={'cross'} />
                </td>
              </tr>
              <tr>
                <th scope="row">Source Of Income(if currency is other than NPR)</th>
                <td>
                  <IconDoc iconName={'cross'} />
                </td>
                <td>
                  <IconDoc iconName={'checked'} />
                </td>
                <td>
                  <IconDoc iconName={'checked'} />
                </td>
              </tr>
              <tr>
                <th scope="row">NRN Related Documents</th>
                <td>
                  <IconDoc iconName={'cross'} />
                </td>
                <td>
                  <IconDoc iconName={'cross'} />
                </td>
                <td>
                  <IconDoc iconName={'checked'} />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div
        className="my-3  p-4 shadow bg-light jumbotron "
        style={{ backgroundColor: '#f2f2f2', borderRadius: '0px' }}
      >
        {/* <div className="row pl-4">
          <div className="col-sm-6 ">
            <p className={'mb-2 mr-2'} style={{ fontSize: '18px', color: '#c41719' }}>
              Do you have an existing account with GIBL?{' '}
            </p>
          </div>
          <div className="col-sm-6">
            <div
              className="row"
              style={{ justifyContent: 'center', fontSize: '16px', fontWeight: 'bold' }}
            >
              <Switch
                name="existing_account"
                id="existing_account"
                onChange={(event) => {
                  formikHandleChange(event, props.setFieldValue, setBtnClass);
                }}
                value={props?.values?.existing_account}
                autoComplete="nope"props.setFieldValue('branchName', event?.code);
                onBlur={props?.handleBlur}
                checked={props?.values?.existing_account}
              />
            </div>
          </div>
          {props.touched.existing_account && props.errors.existing_account && (
            <span className="error">{props.errors.existing_account}</span>
          )}
        </div> */}

        <div className="row pl-4">
          <div className="col-sm-6">
            <p className={'mb-2 mr-2'} style={{ fontSize: '18px', color: '#c41719' }}>
              Are you an NRN?{' '}
            </p>
          </div>
          <div className="col-sm-6">
            <div
              className="row"
              style={{ justifyContent: 'center', fontSize: '16px', fontWeight: 'bold' }}
            >
              <Switch
                name="nrn"
                id="nrn"
                onChange={(event) => {
                  handleCheckboxChange(event, props.setFieldValue, setBtnClass);
                  props.setFieldValue('accountScheme', '');
                  if (event.target.checked) {
                    props.setFieldValue('branchName', 'D1');
                  } else {
                    props.setFieldValue('branchName', '');
                  }
                  setNRN(event.target.checked);
                }}
                value={props?.values?.nrn}
                autoComplete="nope"
                onBlur={props?.handleBlur}
                checked={props?.values?.nrn}
              />
            </div>
          </div>
          {props.touched.existing_account && props.errors.existing_account && (
            <span className="error">{props.errors.existing_account}</span>
          )}
        </div>

        <div className="row pl-4">
          <div className="col-sm-6">
            <p className={'mb-2 mr-2'} style={{ fontSize: '18px', color: '#c41719' }}>
              Account Opening from?{' '}
            </p>
          </div>
          <div className="col-sm-6">
            <div
              className="row"
              style={{
                justifyContent: 'center',
                fontSize: '16px',
                fontWeight: 'bold',
                paddingLeft: '12px',
              }}
            >
              <span
                style={{
                  color: !props?.values?.applyingCountry ? 'rgb(15, 66, 138)' : '#8a888a',
                  fontStyle: 'italic',
                }}
              >
                Inside the Country
              </span>

              <Switch
                name="applyingCountry"
                id="applyingCountry"
                onChange={(event) => {
                  handleCheckboxChange(event, props.setFieldValue, setBtnClass);
                  if (event.target.checked) {
                    props.setFieldValue('country', '');
                  } else {
                    props.setFieldValue('country', 'NP');
                  }
                  // setApplyCountry(event.target.checked);
                }}
                value={props?.values?.applyingCountry}
                autoComplete="nope"
                onBlur={props?.handleBlur}
                checked={props?.values?.applyingCountry}
                hideLabel
              />
              <span
                style={{
                  color: props?.values?.applyingCountry ? 'rgb(15, 66, 138)' : '#8a888a',
                  fontStyle: 'italic',
                }}
              >
                Outside the Country
              </span>
            </div>
          </div>
          {props.touched.existing_account && props.errors.existing_account && (
            <span className="error">{props.errors.existing_account}</span>
          )}
        </div>
        <hr />
        <div className="row mt-3 pl-4">
          <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 mb-2">
            <span className={'m-0 label'}>Select Branch</span>
            <span className="required"> *</span>
            <Select
              options={
                props?.values?.nrn &&
                (!props?.values?.applyingCountry || props?.values?.applyingCountry)
                  ? getOptions(options, 'BranchList')?.reduce((acc, curr) => {
                      if (curr.code === 'D1') {
                        acc.push({ ...curr });
                      }
                      return acc;
                    }, [])
                  : getOptions(options, 'BranchList')
              }
              name="branchName"
              id="branchName"
              placeholder=""
              menuPlacement="top"
              className={`form-control kyc-select ml-n1  ${
                props?.values?.branchName ? 'selected ' : 'not-selected'
              }`}
              data-dropup-auto="false"
              getOptionLabel={(x) => x?.title}
              getOptionValue={(x) => x?.code}
              value={
                getOptions(options, 'BranchList')?.find(
                  (option) => option.code === props?.values?.branchName
                ) ?? { title: '', code: '' }
              }
              onChange={(event) => {
                props.setFieldValue('branchName', event?.code);
              }}
              onBlur={props?.handleBlur}
              styles={{
                singleValue: (provided, state) => ({ ...provided, color: '#a82b37' }),
                control: (base, state) => ({
                  ...base,
                  boxShadow: 'none',
                  borderColor: state?.isFocused ? '#a82b37' : 'hsl(0, 0%, 80%)',
                  borderRadius: '10px',
                  ' &:hover': {
                    borderColor: state?.isFocused ? '#a82b37' : 'hsl(0, 0%, 80%)',
                  },
                  // You can also use state.isFocused to conditionally style based on the focus state
                }),
              }}
            />
            {props?.touched?.branchName && props?.errors?.branchName ? (
              <span className="error">{props?.errors?.branchName}</span>
            ) : null}
          </div>

          {props?.values?.applyingCountry === true ? (
            <>
              <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 mb-2 ">
                <span className={'m-0 label'}>Applying From(Country):</span>
                <span className="required"> *</span>
                <Select
                  options={getOptions(options, 'countryList')?.filter((curr) => {
                    return curr.code !== 'NP';
                  })}
                  name="country"
                  id="country"
                  placeholder=""
                  menuPlacement="top"
                  className={`form-control kyc-select ml-n1 ${
                    props?.values?.country ? 'selected' : 'not-selected'
                  }`}
                  getOptionLabel={(x) => x?.title}
                  getOptionValue={(x) => x?.code}
                  value={getOptions(options, 'countryList')?.find(
                    (option) => option.code === props?.values?.country
                  )}
                  onChange={(event) => {
                    props.setFieldValue('country', event?.code);
                  }}
                  onBlur={props?.handleBlur}
                  styles={{
                    singleValue: (provided, state) => ({ ...provided, color: '#a82b37' }),
                    control: (base, state) => ({
                      ...base,
                      boxShadow: 'none',
                      borderColor: state?.isFocused ? '#a82b37' : 'hsl(0, 0%, 80%)',
                      borderRadius: '10px',
                      ' &:hover': {
                        borderColor: state?.isFocused ? '#a82b37' : 'hsl(0, 0%, 80%)',
                      },
                      // You can also use state.isFocused to conditionally style based on the focus state
                    }),
                  }}
                />
                {props?.touched?.country && props?.errors?.country ? (
                  <span className="error">{props?.errors?.country}</span>
                ) : null}
              </div>
            </>
          ) : props?.values?.applyingCountry === false ? (
            <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 mb-2 ">
              <span className={'m-0 label'}>Applying From(Country):</span>
              {/* <span className="required"> *</span> */}
              <Select
                options={getOptions(options, 'countryList')?.reduce((acc, curr) => {
                  if (curr.code === 'NP') {
                    acc.push({ ...curr });
                  }
                  return acc;
                }, [])}
                name="country"
                id="country"
                menuPlacement="top"
                placeholder=""
                className={`form-control kyc-select ml-n1 ${
                  props?.values?.country ? 'selected' : 'not-selected'
                }`}
                getOptionLabel={(x) => x?.title}
                getOptionValue={(x) => x?.code}
                value={getOptions(options, 'countryList')?.find((option) => option.code === 'NP')}
                onChange={(event) => {
                  props.setFieldValue('country', event?.code);
                }}
                onBlur={props?.handleBlur}
                styles={{
                  singleValue: (provided, state) => ({ ...provided, color: '#a82b37' }),
                  control: (base, state) => ({
                    ...base,
                    boxShadow: 'none',
                    borderColor: state?.isFocused ? '#a82b37' : 'hsl(0, 0%, 80%)',
                    borderRadius: '10px',
                    ' &:hover': {
                      borderColor: state?.isFocused ? '#a82b37' : 'hsl(0, 0%, 80%)',
                    },
                    // You can also use state.isFocused to conditionally style based on the focus state
                  }),
                }}
              />
              {props?.touched?.country && props?.errors?.country ? (
                <span className="error">{props?.errors?.country}</span>
              ) : null}
            </div>
          ) : (
            <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3 mb-2 ">
              <span className={'m-0 label'}>Applying From(Country):</span>
              {/* <span className="required"> *</span> */}
              <Select
                options={getOptions(options, 'countryList')?.reduce((acc, curr) => {
                  if (curr.code !== 'NP') {
                    acc.push({ ...curr });
                  }
                  return acc;
                }, [])}
                name="country"
                id="country"
                menuPlacement="top"
                placeholder=""
                className={`form-control kyc-select ml-n1 ${
                  props?.values?.country ? 'selected' : 'not-selected'
                }`}
                getOptionLabel={(x) => x?.title}
                getOptionValue={(x) => x?.code}
                value={getOptions(options, 'countryList')?.find(
                  (option) => option.code === props?.values?.country
                )}
                onChange={(event) => {
                  props.setFieldValue('country', event?.code);
                }}
                onBlur={props?.handleBlur}
                styles={{
                  singleValue: (provided, state) => ({ ...provided, color: '#a82b37' }),
                  control: (base, state) => ({
                    ...base,
                    boxShadow: 'none',
                    borderColor: state?.isFocused ? '#a82b37' : 'hsl(0, 0%, 80%)',
                    borderRadius: '10px',
                    ' &:hover': {
                      borderColor: state?.isFocused ? '#a82b37' : 'hsl(0, 0%, 80%)',
                    },
                    // You can also use state.isFocused to conditionally style based on the focus state
                  }),
                }}
              />
              {props?.touched?.country && props?.errors?.country ? (
                <span className="error">{props?.errors?.country}</span>
              ) : null}
            </div>
          )}
        </div>
      </div>

      <div className="mt-5">
        {/* {props?.values?.existing_account !== true ? ( */}
        <Fragment>
          <div className="row my-3">
            {props?.values?.branchName &&
              scheme
                ?.filter((scheme) => scheme.active)
                ?.map((scheme, index) => (
                  <SchemeCard {...props} className={className} scheme={scheme} key={index} />
                ))}
          </div>
          {/* <div className="d-flex mb-5 float-right">
              <button type="submit" className={className}>
              Next
              </button>
            </div> */}
        </Fragment>

        {/* // ) : ( */}
        {/* //   <div className="col-sm text-center">
        //     <p>
        //       As per NRB Directive Section no. 16.17 “A natural person cannot open more than one
        //       account of same nature."
        //     </p>
        //   </div> */}
        {/* // )} */}
      </div>
    </>
  );
};

export default EditScheme;
